module.exports = __webpack_public_path__ + "img/coins-white.bd670cdd.svg";